import { render, staticRenderFns } from "./shopCarOrder.vue?vue&type=template&id=6c864d5c&scoped=true&"
import script from "./shopCarOrder.vue?vue&type=script&lang=js&"
export * from "./shopCarOrder.vue?vue&type=script&lang=js&"
import style0 from "./shopCarOrder.vue?vue&type=style&index=0&id=6c864d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c864d5c",
  null
  
)

export default component.exports